export default __webpack_public_path__ + "98020c458249a48d0f76e64ffcf631ce.svg";